import BaseModel from '../core/BaseModel'
export default class GroupUserModel extends BaseModel {

    constructor() {
        super({ 
                name: "group_user",
                tableName: 'group_user',
                label: "Phân Công"
            },
            [{
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            username: {
                name: 'username',
                type: "String", 
                label: 'Tên đăng nhập', 
                filter: {type: 'input', match: 'contains'},
            },
            fullname: {
                name: 'fullname',
                type: "Text",
                label: 'Tên hiển thị',
                filter: {type: 'input', match: 'contains'}
            },
            department_name: {
                name: 'department_name',
                type: "MultiSelect",
                label: 'Bộ phận'
            },
            position_name: {
                name: 'position_name',
                type: "MultiSelect",
                label: 'Chức vụ'
            },
            created_name: {
                type: 'Text',
                name: 'created_name',
                label: 'Người tạo',
            },
            created_at: {
                type: 'Datetime',
                name: 'created_at',
                label: 'Ngày tạo'
            }
        },{
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            name: {
                name: 'name',
                type: "String", 
                label: 'Tên công ty', 
                filter: {type: 'input', match: 'contains'},
            },
            created_name: {
                type: 'Text',
                name: 'created_name',
                label: 'Người tạo',
            },
            created_at: {
                type: 'Datetime',
                name: 'created_at',
                label: 'Ngày tạo'
            }
        }])
    }

}